module.exports = __webpack_public_path__ + "1bb12f4f/img/defaultProductImg.220a180f.svg";